import { ICellRendererParams } from 'ag-grid-community'
import { styled } from '@mui/material'
import { TeamEntity } from '../../../../../domain/entity/TeamEntity'
import { EntityIcon } from '../EntityIcon'

// EntitySearchCellRenderer は他画面でも使う共通コンポーネントで、iconUrl 未設定時に
// 何も描画しない仕様のため、進捗報告専用にアイコン既定表示ありのレンダラーを用意する
export const ProgressReportTeamCellRenderer = ({
  value,
}: ICellRendererParams<unknown, TeamEntity | undefined>) => {
  if (!value) return null

  return (
    <Container>
      <EntityIcon src={value.iconUrl} size={20} />
      <NameText>{value.displayName}</NameText>
    </Container>
  )
}

const Container = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '6px',
  width: '100%',
  height: '100%',
  overflow: 'hidden',
})

const NameText = styled('span')({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
})
